import { CalendarToday } from '@mui/icons-material';
import { Button, Chip, Modal, Skeleton, SvgIcon, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { Box, Container, Stack } from '@mui/system';
import moment from 'moment';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PlusIcon from '@untitled-ui/icons-react/build/esm/Plus';
import { useSettings } from 'src/hooks/use-settings';
import { BasicDateCalendar } from 'src/layouts/components/facility-calender';
import {
  getAllLaborCodes,
  getAllLaborHours,
  resetAddLaborHoursAction,
  resetDeleteLaborHoursAction,
  resetEditLaborHoursAction,
} from 'src/redux/actions/laborHourActions';
import { Seo } from '../seo';
import SucessModal from '../sucess-modal';
import EditLaborManagement from './edit-labor-management';
import LaborHourManagementTable from './laber-hour-management-table';
import {
  convertDateToFacilityDate,
  convertDateToSelectedTimeZone,
  convertIntoIsoFormat,
  toISOWithOffset,
} from 'src/utils/convertDateToSelectedTimeZone';
import useCurrentUser from 'src/hooks/use-current-user';
import useCheckRole from 'src/hooks/use-check-role';
import { permissions } from 'src/paths';

type Props = {};

const getDateInLocalIsoFormat = (date: any) => {
  const dateNewDate = new Date(date);
  return `${moment(dateNewDate).format('YYYY-MM-DD')}T00:00:00.000Z`;
};

const LaborHourManagement = (props: Props) => {
  const settings = useSettings();
  const dispatch = useDispatch();
  const calenderRef = useRef<HTMLDivElement | null>(null);
  const currentDateTime = new Date();
  const convertToSelectTimeZon = new Date(convertDateToSelectedTimeZone(currentDateTime));
  const dateTimeAccordingToFacility = convertDateToFacilityDate(currentDateTime);
  const getAllLaborHrs = useSelector((state: any) => state.getLaborHoursReducer);
  const { LABOR_MANAGEMENT_ADD, LABOR_MANAGEMENT_DELETE, LABOR_MANAGEMENT_UPDATE } = permissions;
  const getFacilityTimeZone = localStorage.getItem('facility_timezone') || '';
  const permissionData = useSelector(
    (state: any) => state?.getTherapistProfileReducer?.response?.data?.currentPermissions
  );
  const [providerId] = useCurrentUser(['providerId']);
  const [isDor] = useCheckRole('dor');
  const [openCalender, setOpenCalender] = useState(false);
  const [selectedDate, setSelectedDate] = useState<any>(() => convertToSelectTimeZon);
  const [openEditHours, setOpenEditHours] = useState(false);
  const [openHoursType, setOpenHoursType] = useState({
    type: '',
    value: '',
  });

  const [createPtoRequestError, setCreatePtoRequestError] = useState(false);
  const [sucessFullRequest, setSucessFullRequest] = useState(false);

  const [rowPerPage, setRowPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const [successModalTitle, setSuccessModalTitle] = useState({
    title: '',
    message: '',
  });
  const addLaborHrsResponse = useSelector((state: any) => state.addLaborHoursReducer);
  const editLaborHrsResponse = useSelector((state: any) => state.editLaborHoursReducer);
  const deleteLaborHrsResponse = useSelector((state: any) => state.deleteLaborHoursReducer);
  const handleClickCalender = useCallback(() => {
    setOpenCalender((prev) => !prev);
  }, []);

  useEffect(() => {
    dispatch(getAllLaborCodes());
  }, []);

  const handleRequestLabor = (item: any) => {
    setOpenHoursType((prev) => ({
      ...prev,
      type: 'EDIT',
      value: item,
    }));
    setOpenEditHours(true);
  };

  const closePTOModal = () => {
    setOpenEditHours(false);
  };

  const handleAddNewData = () => {
    setOpenHoursType((prev) => ({
      ...prev,
      type: 'ADD',
      value: '',
    }));
    setOpenEditHours(true);
  };

  useEffect(() => {
    dispatch(
      getAllLaborHours({
        date: convertIntoIsoFormat(toISOWithOffset(selectedDate)),
        page: page,
        pageSize: rowPerPage,
        providerId: isDor ? null : providerId,
        zoneId: getFacilityTimeZone,
      })
    );
  }, [page, rowPerPage]);

  useEffect(() => {
    dispatch(
      getAllLaborHours({
        date: convertIntoIsoFormat(toISOWithOffset(selectedDate)),
        page: 0,
        pageSize: 10,
        zoneId: getFacilityTimeZone,
        providerId: isDor ? null : providerId,
      })
    );
    setRowPerPage(10);
    setPage(0);
  }, [selectedDate]);

  const jsDate = moment(selectedDate, 'DD-MM-YYYY').toDate();
  const formattedDate = moment(jsDate).format('MMM D, YYYY');
  const currentDate = moment();

  const handleChangeDate = (e: any) => {
    const originalDate = new Date(e);
    setSelectedDate(originalDate);
    setOpenCalender(false);
  };

  useEffect(() => {
    if (openCalender) {
      const handleClickOutside = (event: any) => {
        if (calenderRef.current && !calenderRef.current.contains(event.target)) {
          handleClickCalender();
        }
      };

      document.addEventListener('click', handleClickOutside);

      return () => {
        document.removeEventListener('click', handleClickOutside);
      };
    }
  }, [openCalender]);

  useEffect(() => {
    if (!addLaborHrsResponse?.response && !addLaborHrsResponse?.isAddLaborHours) return;
    if (!addLaborHrsResponse?.isAddLaborHours && addLaborHrsResponse?.response !== null) {
      setSuccessModalTitle((prev) => ({
        ...prev,
        title: 'Error',
        message: addLaborHrsResponse?.response?.message ?? 'Error while Adding Labor management',
      }));
      dispatch(resetAddLaborHoursAction());
      setOpenEditHours(false);
      setOpenHoursType({ type: '', value: '' });
      setCreatePtoRequestError(true);
      setSucessFullRequest(true);
      return;
    }
    if (addLaborHrsResponse?.isAddLaborHours && addLaborHrsResponse?.response?.status == 200) {
      setSuccessModalTitle((prev) => ({
        ...prev,
        title: 'Labor management added successfully !',
        message: '',
      }));
      setOpenEditHours(false);
      setCreatePtoRequestError(false);
      setOpenHoursType({ type: '', value: '' });
      dispatch(
        getAllLaborHours({
          date: convertIntoIsoFormat(toISOWithOffset(selectedDate)),
          page: page,
          zoneId: getFacilityTimeZone,
          pageSize: rowPerPage,
          providerId: isDor ? null : providerId,
        })
      );
      dispatch(resetAddLaborHoursAction());
      setSucessFullRequest(true);

      return;
    }
  }, [addLaborHrsResponse]);

  useEffect(() => {
    if (!editLaborHrsResponse?.response && !editLaborHrsResponse?.isEditLaborHours) return;
    if (!editLaborHrsResponse?.isEditLaborHours && editLaborHrsResponse?.response !== null) {
      setSuccessModalTitle((prev) => ({
        ...prev,
        title: 'Error',
        message: editLaborHrsResponse?.response?.message ?? 'Error while updating labor management',
      }));
      dispatch(resetEditLaborHoursAction());
      setOpenEditHours(false);
      setOpenHoursType({ type: '', value: '' });
      setCreatePtoRequestError(true);
      setSucessFullRequest(true);
      return;
    }
    if (editLaborHrsResponse?.isEditLaborHours && editLaborHrsResponse?.response?.status == 200) {
      setSuccessModalTitle((prev) => ({
        ...prev,
        title: 'Labor management updated successfully !',
        message: '',
      }));
      setOpenEditHours(false);
      setCreatePtoRequestError(false);
      setOpenHoursType({ type: '', value: '' });
      dispatch(
        getAllLaborHours({
          date: convertIntoIsoFormat(toISOWithOffset(selectedDate)),
          page: page,
          zoneId: getFacilityTimeZone,
          pageSize: rowPerPage,
          providerId: isDor ? null : providerId,
        })
      );
      dispatch(resetEditLaborHoursAction());
      setSucessFullRequest(true);

      return;
    }
  }, [editLaborHrsResponse]);

  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  useEffect(() => {
    if (!deleteLaborHrsResponse?.response && !deleteLaborHrsResponse?.isDeletedLaborHours) return;
    if (!deleteLaborHrsResponse?.isDeletedLaborHours && deleteLaborHrsResponse?.response !== null) {
      setSuccessModalTitle((prev) => ({
        ...prev,
        title: 'Error',
        message:
          deleteLaborHrsResponse?.response?.message ??
          'Error while deleting labor management entry',
      }));
      setOpenDeleteModal(false);
      setCreatePtoRequestError(true);
      setSucessFullRequest(true);
      dispatch(resetDeleteLaborHoursAction());
      return;
    }
    if (
      deleteLaborHrsResponse?.isDeletedLaborHours &&
      deleteLaborHrsResponse?.response?.status == 200
    ) {
      setSuccessModalTitle((prev) => ({
        ...prev,
        title: 'Labor management entry deleted successfully !',
        message: '',
      }));
      setOpenDeleteModal(false);
      setCreatePtoRequestError(false);
      dispatch(
        getAllLaborHours({
          date: convertIntoIsoFormat(toISOWithOffset(selectedDate)),
          page: page,
          pageSize: rowPerPage,
          zoneId: getFacilityTimeZone,
          providerId: isDor ? null : providerId,
        })
      );
      dispatch(resetDeleteLaborHoursAction());
      setSucessFullRequest(true);

      return;
    }
  }, [deleteLaborHrsResponse]);

  const closeSuccessModal = () => {
    setSucessFullRequest(false);
  };

  const onRowsPerPageChange = (event: any) => {
    const newRowsPerPage = event.target.value;
    setRowPerPage(newRowsPerPage);
    setPage(0);
  };

  const onPageChange = (event: any, newPage: number) => {
    setPage(newPage);
  };

  return (
    <>
      <Seo title="Restore-Insights: Lobar hour Management" />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 4,
          px: 5,
        }}
      >
        <Container maxWidth={settings.stretch ? false : 'xl'}>
          <Grid
            container
            disableEqualOverflow
            spacing={{
              xs: 3,
              lg: 4,
            }}
          >
            <Grid xs={12}>
              <Stack
                direction="row"
                alignItems="center"
                spacing={4}
              >
                <Stack gap="1rem">
                  <Typography variant="h4">Labor Hour Management</Typography>
                </Stack>

                <Stack ref={calenderRef}>
                  <Button
                    sx={{
                      background: '#fff',
                      borderRadius: '12px',
                      border: '1px solid rgba(17, 25, 39, 0.16)',
                      color: '#384250',
                      '&:hover': {
                        border: '1px solid rgba(17, 25, 39, 0.16)',
                      },
                    }}
                    startIcon={
                      <SvgIcon>
                        <CalendarToday />
                      </SvgIcon>
                    }
                    variant="outlined"
                    onClick={handleClickCalender}
                  >
                    {formattedDate}
                    {moment(jsDate).isSame(convertToSelectTimeZon, 'day') && '(Today)'}
                  </Button>
                  {openCalender ? (
                    <BasicDateCalendar
                      value={selectedDate}
                      handleChangeDate={handleChangeDate}
                      futureDisable={true}
                    />
                  ) : null}
                </Stack>
              </Stack>
            </Grid>
            <Grid xs={12}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', ml: 3 }}>
                  <Typography variant="h6">
                    {'   '}
                    {moment(jsDate).isSame(convertToSelectTimeZon, 'day') && "Today's  "} Therapists
                  </Typography>
                  {getAllLaborHrs?.loading ? (
                    <Box sx={{ width: 100, ml: 3 }}>
                      <Typography
                        width={'100%'}
                        variant="h4"
                      >
                        <Skeleton animation="pulse" />
                      </Typography>
                    </Box>
                  ) : (
                    <Chip
                      label={`${
                        getAllLaborHrs?.response?.totalElements
                          ? getAllLaborHrs?.response?.totalElements
                          : '0'
                      } Therapists`}
                      variant="outlined"
                      sx={{ marginLeft: '10px' }}
                    />
                  )}
                </Box>

                <Box
                  sx={{
                    margin: '20px 11px',
                  }}
                >
                  <Button
                    startIcon={
                      <SvgIcon>
                        <PlusIcon />
                      </SvgIcon>
                    }
                    variant="outlined"
                    onClick={handleAddNewData}
                    disabled={!permissionData?.includes(LABOR_MANAGEMENT_ADD)}
                  >
                    Add New
                  </Button>
                </Box>
              </Box>
              <Stack>
                <LaborHourManagementTable
                  handleRequestLabor={handleRequestLabor}
                  handleAddNewData={handleAddNewData}
                  onRowsPerPageChange={onRowsPerPageChange}
                  onPageChange={onPageChange}
                  page={page}
                  rowPerPage={rowPerPage}
                  openDeleteModal={openDeleteModal}
                  setOpenDeleteModal={setOpenDeleteModal}
                />
              </Stack>
            </Grid>
            <Modal
              open={openEditHours}
              style={{ position: 'relative' }}
            >
              <EditLaborManagement
                close={closePTOModal}
                openHoursType={openHoursType}
                selectedDate={selectedDate}
              />
            </Modal>
            <Modal
              onClose={closeSuccessModal}
              open={sucessFullRequest}
            >
              <SucessModal
                close={closeSuccessModal}
                isSucess={!createPtoRequestError}
                title={successModalTitle.title}
                message={successModalTitle.message}
              />
            </Modal>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default LaborHourManagement;
